import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {LangChange} from '../../../../../../lang-change';
import {Language} from '../../../../../../common/models/language';
import {CatoService} from '../../../../services/cato.service';
import {Cato} from '../../cato/cato';
import {CenterCollegeService} from '../../../../../../common_services/center-college.service';
import {CenterCollege} from '../center-college';
import {Utils} from '../../../../../../common/services/Utils';
import {ActivatedRoute, Router} from '@angular/router';
import {MultiLang} from '../../../../../admin/models/multiLang';
import {ModuleENUM} from '../../../../../../common/enums/module.enum';
import {Principal} from '../../../../../../common/services/principal';
import {ModuleExtendedEdit} from '../../../../../../common/enums/module-extended-edit.enum';

@Component({
  selector: 'app-edit-center-university',
  templateUrl: './edit-center-college.component.html',
  styleUrls: ['./edit-center-college.component.scss']
})
export class EditCenterCollegeComponent extends LangChange implements OnInit {

  id: number;
  isDataFetched: boolean;
  university: CenterCollege;
  form: FormGroup;
  combinedUniversities: CenterCollege[];
  separatedUniversities: CenterCollege[];
  openedUniversities: CenterCollege[];
  types: MultiLang[];
  forms: MultiLang[];
  states: MultiLang[];
  closeReasons: MultiLang[];
  creationTypes: MultiLang[];
  catoList: Cato[];
  openYearList: number[];
  closeYearList: number[];
  isNew: boolean;
  hasWriteAccess = false;
  isAdmin = false;
  universityConst: any = {
    state: {
      OPENED: 1,
      CLOSED: 2
    },
    creationType: {
      COMBINED: 2,
      SEPARATED: 3
    },
    closeReason: {
      SEPARATE: 3,
      JOIN_TO_ANOTHER: 4
    }
  };

  constructor(private _route: ActivatedRoute,
              private _router: Router,
              private _utils: Utils,
              public _principal: Principal,
              private _centerUniversityService: CenterCollegeService,
              protected _translateService: TranslateService,
              private _catoService: CatoService) {
    super(_translateService);
  }

  ngOnInit() {
    this.isAdmin = this._principal.isRegionAdmin() || this._principal.isAdmin();
    this.hasWriteAccess = this.isAdmin ||
      (this._principal.hasWriteAccess(ModuleENUM.DICTIONARY) && this._principal.hasModuleExtendedEdit(ModuleENUM.DICTIONARY, ModuleExtendedEdit.DATA_EDIT));
    this.generateYears();
    this._route.params.subscribe(
      params => {
        this.id = +params['id'];
        if (this.id !== 0) {
          this.getData();
        } else {
          this.initForm(true);
        }
      }
    );
    this.getCombinedList();
    this.getSeparatedList();
    this.getOpenedUniversities();
    this.getTypes();
    this.getForms();
    this.getStates();
    this.getCloseReasons();
    this.getCreationTypes();
    this.getCatoList();
  }

  getData() {
    this._centerUniversityService.getDictionaryById(this.id).subscribe(
      data => {
        this.university = data;
        this.isDataFetched = true;
        this.initForm(false);
      }
    );
  }

  initForm(isNew: boolean) {
    if (isNew) {
      this.university = new CenterCollege();
      this.isNew = isNew;
    }
    this.updateLocalizedUniversityData();
    this.form = new FormGroup({
      'nameKz': new FormControl(isNew ? null : this.university.nameKz, Validators.required),
      'nameRu': new FormControl(isNew ? null : this.university.nameRu, Validators.required),
      'nameEn': new FormControl(isNew ? null : this.university.nameEn, Validators.required),
      'state': new FormControl({value: isNew ? null : this.university.state, disabled: !this.hasWriteAccess}, Validators.required),
      'type': new FormControl({value: isNew ? null : this.university.type, disabled: !this.hasWriteAccess}, Validators.required),
      'form': new FormControl({value: isNew ? null : this.university.form, disabled: !this.hasWriteAccess}, Validators.required),
      'cato': new FormControl({value: isNew ? null : this.university.cato, disabled: !this.hasWriteAccess}, Validators.required),
      'openYear': new FormControl({value: isNew ? null : this.university.openYear, disabled: !this.hasWriteAccess}),
      'reasonClosed': new FormControl({value: isNew ? null : this.university.closeReason, disabled: !this.hasWriteAccess}),
      'closeYear': new FormControl({value: isNew ? null : this.university.closeYear, disabled: !this.hasWriteAccess}),
      'afterSeparateCount': new FormControl(isNew ? null : this.university.afterSeparateCount),
      'universityJoinedWith': new FormControl({value: isNew ? null : this.university.universityJoinedWith, disabled: !this.hasWriteAccess}),
      'creationType': new FormControl(isNew || !this.university.creationType ? 1 : this.university.creationType.id),
      'combinedUniversities': new FormControl({value: isNew ? [] : this.university.combinedUniversityList, disabled: !this.hasWriteAccess}),
      'separatedUniversity': new FormControl({value: isNew ? null : this.university.separatedUniversity, disabled: !this.hasWriteAccess}),
      'responsibleForDoc': new FormControl(isNew ? false : this.university.responsibleForDoc),
      'url': new FormControl(isNew ? false : this.university.url),
      'urlForRegEnrolls': new FormControl(isNew ? false : this.university.urlForRegEnrolls)
    });
    this.stateChanged();
    this.creationTypeChanged();
  }

  onSave() {
    if (this.form.invalid) {
      this._utils.notifyError('write_all_with_*', null);
      return;
    }
    this.university.nameKz = this.form.get('nameKz').value;
    this.university.nameRu = this.form.get('nameRu').value;
    this.university.nameEn = this.form.get('nameEn').value;
    this.university.state = this.form.get('state').value;
    this.university.type = this.form.get('type').value;
    this.university.form = this.form.get('form').value;
    this.university.cato = this.form.get('cato').value;
    this.university.responsibleForDoc = this.form.get('responsibleForDoc').value;
    this.university.urlForRegEnrolls = this.form.get('urlForRegEnrolls').value;
    this.university.url = this.form.get('url').value;
    this.university.creationType = this.getObjectByID(this.form.get('creationType').value, this.creationTypes);
    this.university.openYear = this.form.get('openYear').value;
    this.university.combinedUniversityList = this.form.get('creationType').value != this.universityConst.creationType.COMBINED
      ? null : this.form.get('combinedUniversities').value;
    this.university.separatedUniversity = this.form.get('creationType').value != this.universityConst.creationType.SEPARATED
      ? null : this.form.get('separatedUniversity').value;

    if (this.form.get('state').value.id === this.universityConst.state.CLOSED) {
      if (this.form.get('closeYear').value < this.form.get('openYear').value) {
        this._utils.notifyError('open_year_cannot_be_greater_than_close_year', null);
        return;
      }
      this.university.closeReason = this.form.get('reasonClosed').value;
      this.university.afterSeparateCount = this.form.get('reasonClosed').value.id === this.universityConst.closeReason.SEPARATE
        ? this.form.get('afterSeparateCount').value : null;
      this.university.universityJoinedWith = this.form.get('reasonClosed').value.id === this.universityConst.closeReason.JOIN_TO_ANOTHER
        ? this.form.get('universityJoinedWith').value : null;
      this.university.closeYear = this.form.get('closeYear').value;
    } else {
      this.university.afterSeparateCount = null;
      this.university.closeReason = null;
      this.university.closeYear = null;
    }
    this._centerUniversityService.save(this.university).subscribe(
      response => {
        if (response.status !== 'ERROR') {
          this._utils.notifySuccess(this._translateService.instant('saved'), null);
          if (this.isNew) {
            this._router.navigate(['user/center-college', response.data.id]);
          }
        }
      },
      error => {
        console.error(error);
        this._utils.notifyError('error_occurred', null);
        this.getData();
      }
    );
  }

  stateChanged(): void {
    this.form.get('reasonClosed').clearValidators();
    this.form.get('closeYear').clearValidators();
    if (this.form.get('state').value && this.form.get('state').value.id === this.universityConst.state.CLOSED) {
      this.form.get('reasonClosed').setValidators([Validators.required]);
      this.form.get('closeYear').setValidators([Validators.required]);
    } else {
      this.form.get('reasonClosed').setValue(null);
      this.form.get('closeYear').setValue(null);
    }
    this.form.get('reasonClosed').updateValueAndValidity();
    this.form.get('closeYear').updateValueAndValidity();
  }

  creationTypeChanged(): void {
    this.form.get('combinedUniversities').clearValidators();
    this.form.get('separatedUniversity').clearValidators();
    if (this.form.get('creationType').value == this.universityConst.creationType.COMBINED) {
      this.form.get('combinedUniversities').setValidators([Validators.required]);
    } else if (this.form.get('creationType').value == this.universityConst.creationType.SEPARATED) {
      this.form.get('separatedUniversity').setValidators([Validators.required]);
    }
    this.form.get('combinedUniversities').updateValueAndValidity();
    this.form.get('separatedUniversity').updateValueAndValidity();
  }

  getTypes() {
    this._centerUniversityService.getTypes().subscribe(
      data => {
        this.types = data;
        Language.updateListLocalizedName(this.types);
      }
    );
  }

  getCombinedList() {
    this._centerUniversityService.getCombined(this.id).subscribe(
      data => {
        this.combinedUniversities = data;
        Language.updateListLocalizedName(this.combinedUniversities);
      }
    );
  }

  getSeparatedList() {
    this._centerUniversityService.getSeparated(this.id).subscribe(
      data => {
        this.separatedUniversities = data;
        Language.updateListLocalizedName(this.separatedUniversities);
      }
    );
  }

  getOpenedUniversities() {
    this._centerUniversityService.getOpenedUniversities(this.id).subscribe(
      data => {
        this.openedUniversities = data;
        Language.updateListLocalizedName(this.openedUniversities);
      }
    );
  }

  getForms() {
    this._centerUniversityService.getForms().subscribe(
      data => {
        this.forms = data;
        Language.updateListLocalizedName(this.forms);
      }
    );
  }

  getCatoList() {
    this._catoService.getAll().subscribe(
      data => {
        this.catoList = data;
        Language.updateListLocalizedFullName(this.catoList);
      }
    );
  }

  getStates() {
    this._centerUniversityService.getStates().subscribe(
      data => {
        this.states = data;
        Language.updateListLocalizedName(this.states);
      }
    );
  }

  getCloseReasons() {
    this._centerUniversityService.getCloseReasons().subscribe(
      data => {
        this.closeReasons = data;
        Language.updateListLocalizedName(this.closeReasons);
      }
    );
  }

  getCreationTypes() {
    this._centerUniversityService.getCreationTypes().subscribe(
      data => {
        this.creationTypes = data;
        Language.updateListLocalizedName(this.creationTypes);
      }
    );
  }

  generateYears() {
    this.openYearList = [];
    this.closeYearList = [];
    for (let i = +(new Date().getFullYear() - 1900); i >= 0; i--) {
      this.openYearList.push(i + 1900);
    }
    for (let i = +(new Date().getFullYear() - 1950); i >= 0; i--) {
      this.closeYearList.push(i + 1950);
    }
  }

  getObjectByID(id: number, list: any[]): any {
    for (let i = 0; i < list.length; i++) {
      if (list[i].id == id) {
        return list[i];
      }
    }
    return {};
  }

  onLangChange(langCode) {
    this.updateLocalizedUniversityData();
    Language.updateLocalizedName(this.university);
    Language.updateListLocalizedName(this.forms);
    Language.updateListLocalizedName(this.types);
    Language.updateListLocalizedName(this.states);
    Language.updateListLocalizedName(this.closeReasons);
  }

  updateLocalizedUniversityData(): void {
    Language.updateLocalizedName(this.university);
    Language.updateLocalizedName(this.university.state);
    Language.updateLocalizedName(this.university.universityJoinedWith);
    Language.updateLocalizedName(this.university.form);
    Language.updateLocalizedName(this.university.type);
    Language.updateLocalizedName(this.university.closeReason);
    Language.updateLocalizedName(this.university.separatedUniversity);
    Language.updateLocalizedFullName(this.university.cato);
    Language.updateListLocalizedName(this.university.combinedUniversityList);
    Language.updateListLocalizedName(this.university.joinedUniversityList);
    Language.updateListLocalizedName(this.university.afterSeparateUniversityList);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/dictionary/university/edit/edit-center-college.component.ts